import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useState } from "react";
import { PLANTUML_DEFAULT_URL } from "../Constants";

export default function SettingsDialog({
  initialValue,
  handleYes,
  handleNo,
  dialogOpen,
}) {
  const [value, setValue] = useState(initialValue);
  const [errorMessage, setErrorMessage] = useState("");

  function isValidURL(str) {
    try {
      new URL(str);
      return true;
    } catch (_) {
      return false;
    }
  }

  async function isServerReachable(url) {
    try {
      await fetch(url, { method: "GET", mode: "no-cors" });
      return true; // If no exception is thrown, it's reachable
    } catch (error) {
      return false;
    }
  }

  const restoreDefault = () => {
    setValue(PLANTUML_DEFAULT_URL);
    handleYes(value);
  };

  const checkValue = async () => {
    if (!isValidURL(value)) {
      setErrorMessage("Invalid URL");
      return;
    }

    setErrorMessage("Checking...");

    const reachable = await isServerReachable(value);
    if (reachable) {
      setErrorMessage("");
      if (!value.endsWith("/")) {
        handleYes(value + "/");
      } else {
        handleYes(value);
      }
    } else {
      setErrorMessage("Server is not reachable");
    }
  };

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleNo}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>Customer PlantUML Server URL</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Custom URL"
          placeholder="Enter your plantUML server URL here"
          fullWidth
          variant="outlined"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setErrorMessage("");
          }}
        />
        <Typography style={{ color: "#F00" }}>{errorMessage}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={restoreDefault}
          style={{ float: "left" }}
        >
          Restore Default
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        <Button color="secondary" variant="contained" onClick={handleNo}>
          Cancel
        </Button>
        <Button variant="contained" onClick={checkValue} autoFocus>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
